import { SearchSupplierRes } from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class SearchSupplierGateway {
  /**
   * 業者検索-明細取得（Xgrab） API
   */
  static getSearchSupplierXgrabList = async (supplierNm?: string) => {
    const params = {
      supplierNm
    }
    return await yamadumiApi.get<SearchSupplierRes>(
      '/api/common/search-supplier/xgrab',
      params
    )
  }

  /**
   * 業者検索-明細取得（業者マスタ） API
   */
  static getSearchSupplierList = async (supplierNm?: string, expense?: string) => {
    const params = {
      supplierNm,
      expense
    }
    return await yamadumiApi.get<SearchSupplierRes>(
      '/api/common/search-supplier',
      params
    )
  }
}
